import { createSelector } from '@reduxjs/toolkit';
import { selectFloorsCount } from 'shared/selectors/jsonQuery';

export const selectSuburbanFloorsValue = createSelector(selectFloorsCount, value => {
  switch (true) {
    case value.lte === 1 && (!value.gte || value.gte === 1):
      return 1;

    case (value.gte === 2 && (!value.lte || value.lte >= 2)) || (!value.gte && value.lte && value.lte >= 2):
      return 2;

    default:
      return null;
  }
});
